export default __webpack_public_path__ + "static/media/Dev3.ac190335.png";